import { render, staticRenderFns } from "./DataDangerList.vue?vue&type=template&id=1f34b0c1&scoped=true"
import script from "./DataDangerList.vue?vue&type=script&lang=js"
export * from "./DataDangerList.vue?vue&type=script&lang=js"
import style0 from "./DataDangerList.vue?vue&type=style&index=0&id=1f34b0c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34b0c1",
  null
  
)

export default component.exports